import VacationUserSubordibationArchive from 'features/vacations/vacationUserSubordinatesArchive';
import { useTitle } from '../helpers';

/**
 * @page Vacations user subordinates archive page
 */
const VacationsUserSubordinationArchivePage = () => {
  useTitle('Информация о заявлении в архиве подчинённых');

  return (
    <div>
      <h3>Информация о заявлении в архиве подчинённых</h3>
      <VacationUserSubordibationArchive />
    </div>
  );
};

export default VacationsUserSubordinationArchivePage;
